<script>

    import {createEventDispatcher} from "svelte";
    const dispatch = createEventDispatcher();

    import VariantSelector from "./VariantSelector.svelte";
    import ModSelector from "./ModSelector.svelte";

    export let prices = [];
    export let mods = [];
    export let currency = undefined;

    function changeHandler () {
        dispatch('changed', {prices, mods});
    }

</script>

<style>
    hr {
        height: 1px;
        border: none;
        border-top: 1px solid var(--cart-items-separator);
        opacity: .2;
        margin: 1.25rem 0;
    }
    ul {
        padding-top: .5rem;
    }
    ul li:last-child hr {
        display: none;
    }
</style>

<ul>
    {#if (prices?.length > 1)}
        <li>
            <VariantSelector prices={prices} currency={currency} on:changed={changeHandler}></VariantSelector>
            <hr>
        </li>
    {/if}

    {#if (mods)}
        {#each mods as mod}
            <li>
                <ModSelector mod={mod} currency={currency} on:changed={changeHandler}></ModSelector>
                <hr>
            </li>
        {/each}
    {/if}
</ul>
